import React, { useRef, useEffect } from 'react';
import './Footer.css';

import { gsap } from 'gsap';

const Footer = () => {
  const footerRef = useRef();

  useEffect(() => {
    gsap.from(footerRef.current, {
      y: 20,
      duration: 0.6,
      ease: 'power2.out',
    });
  }, []);

  return (
    <footer className="footerContainer" ref={footerRef}>
      <small>&copy; 2024 - Todos os direitos reservados.</small>
    </footer>

  );
};

export default Footer;
